import { z } from "zod";

import { AmplitudeEventIds } from "../constants";

import { amplitudeEvent } from "./base";

export const OverviewPageAddTileEvent = amplitudeEvent(
  {
    id: AmplitudeEventIds.OVERVIEW_PAGE_ADD_TILE,
    camelCaseName: "overviewPageAddTile",
    label: "Overview page add tile",
  },
  {
    type: z.string(),
    metricId: z.string(),
    name: z.string(),
    breakdowns: z.array(z.string()),
    breakdownFilters: z.array(z.array(z.string())),
    filters: z.array(
      z.object({
        breakdown: z.string(),
        value: z.string(),
      }),
    ),
  },
);

export const OverviewPageSelectDateRangeCustom = amplitudeEvent(
  {
    id: AmplitudeEventIds.OVERVIEW_PAGE_SELECT_DATE_RANGE_CUSTOM,
    camelCaseName: "overviewPageSelectCustomDateRange",
    label: "Overview page select daterange",
  },
  {
    startDate: z.string(),
    endDate: z.string(),
    type: z.string(),
  },
);

export const OverviewPageSelectDateRangePredefined = amplitudeEvent(
  {
    id: AmplitudeEventIds.OVERVIEW_PAGE_SELECT_DATE_RANGE_PREDEFINED,
    camelCaseName: "overviewPageSelectPredefinedDateRange",
    label: "Overview page select daterange",
  },
  {
    shortcutDateRange: z.string(),
  },
);

export const OVERVIEW_PAGE_EVENTS = [
  OverviewPageAddTileEvent,
  OverviewPageSelectDateRangeCustom,
  OverviewPageSelectDateRangePredefined,
] as const;
